import { Filter } from '../groups-filters/groups-filters.interface';

export enum GroupMemberInterface {
  Team = 'team',
  Company = 'company',
  Brand = 'brand',
  ExistingUser = 'existingUser',
  EmailAddress = 'emailAddress',
}

export interface GroupInterface {
  id: string;
  name: string;
  description: string;
  memberType: GroupMemberInterface;
  members: string[];
}

export interface GetMembersParams {
  pagination: {
    page?: number;
    limit?: number;
    search?: string;
    selectedMembers?: string[];
  };
  filter?: {
    filters: Filter[];
    cacheId?: string;
  };
}
